import { Countries } from './../../../utils/countries-enum';
import { DynamicComponentManifest } from '../../../dynamic-component-loader/dynamic-component-manifest';
import { DynamicArrayGenerator } from '../../../utils/dynamic-array-generator';

export class AustraliaManifest {
  da: DynamicArrayGenerator;
  constructor() {
    this.da = new DynamicArrayGenerator();
  }
  public getAUSManifest(): DynamicComponentManifest[] {
    const components = [
      {
        'key': 'tax-fee',
        'module': 'GlobalModule'
      },
      {
        'key': 'company-names',
        'module': 'GlobalModule'
      },
      {
        'key': 'gst-fee-field',
        'module': 'GlobalModule'
      },
      {
        'key': 'invoice-header',
        'module': 'GlobalModule'
      },
      {
        'key': 'gws-entity-location',
        'module': 'GlobalModule'
      },
      {
        'key': 'miq-property-id',
        'module': 'GlobalModule'
      },
      {
        'key': 'billing-information',
        'module': 'GlobalModule'
      },
      {
        'key': 'tax-fee-percent',
        'module': 'GlobalModule'
      },
      {
        'key': 'office',
        'module': 'GlobalModule'
      },
      {
        'key': 'edp-account-contact',
        'module': 'GlobalModule'
      },
      {
        'key': 'autocomplete-multiple-columns',
        'module': 'GlobalModule'
      },
      {
        'key': 'invoice-address-form',
        'module': 'GlobalModule'
      },
      {
        'key': 'joint-agent',
        'module': 'GlobalModule'
      },
    ];
    // tslint:disable-next-line: no-use-before-declare
    return this.da.generateManifest(components, Countries.Australia);
  }
}
